<template>
  <card dis-hover class="bgs-item" @click.native="editBg">
    <div class="bgs-item__common-info">
      <div class="bgs-item__header">
        <div class="bgs-item__numbers">
          <div class="ms-subhead">БГ № {{ bg.number || "б/н" }}</div>
          <div class="ms-text">{{ bg.tracking_number ? `(уч. № ${bg.tracking_number})` : '' }}</div>
        </div>

        <div class="bgs-item__header-statuses">
          <tag class="status bg" :color="getBgStatusColor(bgStatus.value)">
            {{ bgStatus.name }}
          </tag>
        </div>
      </div>

      <div class="bgs-item__type">
        <tag class="ms-costs" color="primary">
          {{ getFormattedCosts(bg.amount, true) }} руб.
        </tag>

        <tag class="status bg">
          {{ bg.bg_types_name }}
        </tag>
      </div>

      <div class="bgs-item__dates">
        <span class="ms-help"> Сроки: {{ datesLabel }} </span>
        <span class="ms-help">
          {{ daysCountLabel }}
        </span>
      </div>

      <div class="bgs-item__bank ms-help">
        Банк, выдавший гарантию: {{ bg.bank_name || "не указан" }}
      </div>
    </div>

    <div class="bgs-item__subinfo">
      <div class="bgs-item__subinfo-header ms-help">
        Информация о Заказчике
      </div>

      <div class="bgs-item__subinfo-row">
        <span class="ms-text">Компания: {{ contract.customer }}</span>
      </div>

      <div class="bgs-item__subinfo-row">
        <span class="ms-text"
          >Объект: {{ contract.code }}. {{ contract.name }}</span
        >
      </div>

      <div class="bgs-item__subinfo-row">
        <span class="ms-text">
          Контакты: {{ bg.contact_fio }}, {{ bg.contact_phone }},
          {{ bg.contact_email }}
        </span>
      </div>
    </div>
  </card>
</template>

<script>
import moment from 'moment'
import {
  getFormattedCosts,
  formatDefaultDate,
  getBgStatusColor
} from '@/utils'

export default {
  props: ['bg'],
  computed: {
    contract () {
      return this.$store.state.contracts.current
    },
    bgStatus () {
      const { start_date, end_date } = this.bg

      if (!end_date) {
        return {
          value: 'default',
          name: 'Проект БГ'
        }
      }

      const startDate = moment(start_date, 'YYYY-MM-DD')
      const endDate = moment(end_date, 'YYYY-MM-DD')
      const nowDate = moment()

      const startDiff = startDate.diff(nowDate, 'minutes')
      const endDiff = endDate.diff(nowDate, 'minutes')

      if (startDiff >= 0) {
        return {
          value: 'default',
          name: 'Проект БГ'
        }
      }

      if (endDiff >= 0) {
        return {
          value: 'open',
          name: 'Текущая'
        }
      }

      return {
        value: 'closed',
        name: 'Закрыта'
      }
    },
    datesLabel () {
      const { start_date, end_date } = this.bg

      return `${formatDefaultDate(start_date)} – ${formatDefaultDate(
        end_date
      )}`
    },
    datesRest () {
      const { end_date } = this.bg

      if (!end_date) return null

      return moment(end_date, 'YYYY-MM-DD').diff(moment(), 'days') + 1
    },
    daysCountLabel () {
      const { start_date, end_date } = this.bg

      const days = moment(end_date, 'YYYY-MM-DD').diff(
        moment(start_date, 'YYYY-MM-DD'),
        'days'
      )

      if (this.datesRest > 0) {
        return `(всего ${days} дн., осталось ${this.datesRest} дн.)`
      }

      return `(всего ${days} дн.)`
    }
  },
  methods: {
    editBg () {
      this.$emit('edit', this.bg)
    },
    formatDefaultDate,
    getFormattedCosts,
    getBgStatusColor
  }
}
</script>

<style lang="less">
.bgs-item {
  margin-bottom: 16px;
  cursor: pointer;

  .ivu-card-body {
    display: flex;
    gap: 80px;
  }

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  &__common-info {
    width: 40%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-statuses {
      display: flex;
      gap: 8px;
    }
  }

  &__numbers {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__type {
    display: flex;
    align-items: center;
    gap: 32px;

    .status {
      flex: 1;
    }
  }

  &__dates {
    gap: 4px;
  }

  &__subinfo {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &-header {
      margin-bottom: 8px;
    }
  }
}
</style>
